// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-form {
  box-shadow: 12px 12px 48px rgb(var(--surface-50)/50), -12px -12px 48px rgb(var(--surface-50)/50);
  max-height: 900px;
  max-width: 640px;
}
@media only screen and (max-width: 1199px) {
  .login-form {
    box-shadow: none;
  }
}
.login-form > * {
  width: 100%;
}
.login-form button {
  padding: 1.2rem 0;
}
.login-form button .p-button .p-button-icon-left {
  margin-right: 0em;
}
.login-form button .p-button-label {
  flex: initial;
}
.login-form > span:before, .login-form > span:after {
  content: "";
  position: absolute;
  top: 50%;
  translate: 0 -50%;
  width: calc(50% - 1rem);
  height: 1px;
  background: #6b6b6b;
  border-radius: 8px;
}
.login-form > span:before {
  left: 0;
}
.login-form > span:after {
  right: 0;
}
.login-form [for=password] + button {
  background: none;
  right: 0.5rem;
}
.login-form .p-formgroup-signup span {
  letter-spacing: -0.6px;
}

:host ::ng-deep .oauth-container .p-button-label {
  flex: 0 0 auto;
}
:host ::ng-deep .iti {
  padding-block: 0;
}
:host ::ng-deep .iti .iti__selected-flag {
  margin: 10px 0px 10px 10px;
  padding: 0 6px 0 8px;
  height: 35px;
  border-radius: 6px;
}
:host ::ng-deep .iti .iti__selected-flag:hover {
  background: var(--surface-ground);
}
:host ::ng-deep .iti input {
  padding-left: 73px !important;
}
:host ::ng-deep .iti .iti__selected-flag[aria-expanded=true] {
  background: var(--surface-ground);
  box-shadow: 0 0 0 1px var(--surface-900);
}
:host ::ng-deep .iti .iti__country {
  color: var(--surface-0);
}
:host ::ng-deep .iti + label {
  transition: all 0.2s linear;
}
:host ::ng-deep .iti:has(input.p-filled,
input[placeholder],
input:not(:placeholder-shown),
input:focus) {
  border-color: transparent;
  outline: 0;
  box-shadow: none;
}
:host ::ng-deep .iti:has(input.p-filled,
input[placeholder],
input:not(:placeholder-shown),
input:focus) ~ .input-overlay {
  --border-color: var(--surface-100);
}
:host ::ng-deep .iti:has(input.p-filled,
input[placeholder],
input:not(:placeholder-shown),
input:focus) + label {
  font-size: 0.8rem;
  color: var(--surface-900);
  border-radius: 8px;
  padding-inline: 0.5rem;
}
:host ::ng-deep .iti.ng-valid ~ .input-overlay {
  --border-color: #93deac !important;
}
:host ::ng-deep .iti.ng-invalid ~ .input-overlay {
  --border-color: #ff9a9a !important;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/register-form/register-form.component.scss"],"names":[],"mappings":"AAMA;EACE,gGAAA;EAEA,iBAAA;EACA,gBAAA;AANF;AAHE;EAKF;IAOI,gBAAA;EALF;AACF;AAOE;EACE,WAAA;AALJ;AAQE;EACE,iBAAA;AANJ;AAQI;EACE,iBAAA;AANN;AASI;EACE,aAAA;AAPN;AAYI;EAEE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,iBAAA;EACA,uBAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;AAXN;AAcI;EACE,OAAA;AAZN;AAeI;EACE,QAAA;AAbN;AAiBE;EACE,gBAAA;EACA,aAAA;AAfJ;AAmBI;EACE,sBAAA;AAjBN;;AAuBE;EACE,cAAA;AApBJ;AAuBE;EACE,gBAAA;AArBJ;AAuBI;EACE,0BAAA;EACA,oBAAA;EACA,YAAA;EACA,kBAAA;AArBN;AAuBM;EACE,iCAAA;AArBR;AAyBI;EACE,6BAAA;AAvBN;AA0BI;EACE,iCAAA;EACA,wCAAA;AAxBN;AA2BI;EACE,uBAAA;AAzBN;AA4BI;EACE,2BAAA;AA1BN;AA6BI;;;;EAME,yBAAA;EACA,UAAA;EACA,gBAAA;AA7BN;AA+BM;;;;EACE,kCAAA;AA1BR;AA6BM;;;;EACE,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,sBAAA;AAxBR;AA4BI;EACE,kCAAA;AA1BN;AA6BI;EACE,kCAAA;AA3BN","sourcesContent":["@mixin md() {\r\n  @media only screen and (max-width: 1199px) {\r\n    @content;\r\n  }\r\n}\r\n\r\n.login-form {\r\n  box-shadow: 12px 12px 48px rgb(var(--surface-50) / 50),\r\n    -12px -12px 48px rgb(var(--surface-50) / 50);\r\n  max-height: 900px;\r\n  max-width: 640px;\r\n\r\n  @include md() {\r\n    box-shadow: none;\r\n  }\r\n\r\n  > * {\r\n    width: 100%;\r\n  }\r\n\r\n  button {\r\n    padding: 1.2rem 0;\r\n\r\n    .p-button .p-button-icon-left {\r\n      margin-right: 0em;\r\n    }\r\n\r\n    .p-button-label {\r\n      flex: initial;\r\n    }\r\n  }\r\n\r\n  > span {\r\n    &:before,\r\n    &:after {\r\n      content: \"\";\r\n      position: absolute;\r\n      top: 50%;\r\n      translate: 0 -50%;\r\n      width: calc(50% - 1rem);\r\n      height: 1px;\r\n      background: #6b6b6b;\r\n      border-radius: 8px;\r\n    }\r\n\r\n    &:before {\r\n      left: 0;\r\n    }\r\n\r\n    &:after {\r\n      right: 0;\r\n    }\r\n  }\r\n\r\n  [for=\"password\"] + button {\r\n    background: none;\r\n    right: 0.5rem;\r\n  }\r\n\r\n  .p-formgroup-signup {\r\n    span {\r\n      letter-spacing: -0.6px;\r\n    }\r\n  }\r\n}\r\n\r\n:host ::ng-deep {\r\n  .oauth-container .p-button-label {\r\n    flex: 0 0 auto;\r\n  }\r\n\r\n  .iti {\r\n    padding-block: 0;\r\n\r\n    .iti__selected-flag {\r\n      margin: 10px 0px 10px 10px;\r\n      padding: 0 6px 0 8px;\r\n      height: 35px;\r\n      border-radius: 6px;\r\n\r\n      &:hover {\r\n        background: var(--surface-ground);\r\n      }\r\n    }\r\n\r\n    input {\r\n      padding-left: 73px !important;\r\n    }\r\n\r\n    .iti__selected-flag[aria-expanded=\"true\"] {\r\n      background: var(--surface-ground);\r\n      box-shadow: 0 0 0 1px var(--surface-900);\r\n    }\r\n\r\n    .iti__country {\r\n      color: var(--surface-0);\r\n    }\r\n\r\n    & + label {\r\n      transition: all 0.2s linear;\r\n    }\r\n\r\n    &:has(\r\n        input.p-filled,\r\n        input[placeholder],\r\n        input:not(:placeholder-shown),\r\n        input:focus\r\n      ) {\r\n      border-color: transparent;\r\n      outline: 0;\r\n      box-shadow: none;\r\n\r\n      & ~ .input-overlay {\r\n        --border-color: var(--surface-100);\r\n      }\r\n\r\n      & + label {\r\n        font-size: 0.8rem;\r\n        color: var(--surface-900);\r\n        border-radius: 8px;\r\n        padding-inline: 0.5rem;\r\n      }\r\n    }\r\n\r\n    &.ng-valid ~ .input-overlay {\r\n      --border-color: #93deac !important;\r\n    }\r\n\r\n    &.ng-invalid ~ .input-overlay {\r\n      --border-color: #ff9a9a !important;\r\n    }\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
